import React from 'react'

import {
    AlertBoxBGDiv,
    AlertBoxDiv,
    AlertBoxComponentsDiv,
    AlertBoxContentsDiv,
    AlertBoxTopDiv,
    AlertBoxTitleDiv,
    AlertBoxTitle,
    AlertBoxExitDiv,
    AlertBoxRedXButton,
    AlertBoxPhraseDiv,
    AlertBoxPhrase,
    AlertBoxButtonsDiv,
    AlertBoxActionButton
} from '../../Styles/Components/AlertBoxStyles'

function AlertBox(props) {
    let alertInfo = props.alertInfo

    let alertTitle = alertInfo.alert_title
    let alertPhrase = alertInfo.alert_phrase
    let alertType = alertInfo.alert_type
    let style = alertInfo.style

    var showX = true

    switch(alertType){
        case 'action':
            showX = false
            break
        case 'display':
            showX = true
            break
        default:
            break
    }

    return (
        <AlertBoxBGDiv>
            <AlertBoxDiv>
                <AlertBoxComponentsDiv>
                    <AlertBoxContentsDiv>
                        <AlertBoxTopDiv>
                            <AlertBoxTitleDiv>
                                <AlertBoxTitle style={style.alert_title}>{alertTitle}</AlertBoxTitle>
                            </AlertBoxTitleDiv>
                            {showX ? 
                                <AlertBoxExitDiv>
                                    <AlertBoxRedXButton onClick={alertInfo.exitFunction}/>
                                </AlertBoxExitDiv> 
                            : null}
                        </AlertBoxTopDiv>
                        <AlertBoxPhraseDiv>
                            <AlertBoxPhrase style={style.alert_phrase}>{alertPhrase}</AlertBoxPhrase>
                        </AlertBoxPhraseDiv>
                        {showX ? null :
                            <AlertBoxButtonsDiv>
                                <AlertBoxActionButton onClick={alertInfo.secondary_button_function} style={style.secondary_button}>{alertInfo.secondary_button_text}</AlertBoxActionButton>
                                <AlertBoxActionButton onClick={alertInfo.primary_button_function} style={style.primary_button}>{alertInfo.primary_button_text}</AlertBoxActionButton>
                            </AlertBoxButtonsDiv>
                        }
                    </AlertBoxContentsDiv>
                </AlertBoxComponentsDiv>
            </AlertBoxDiv>
        </AlertBoxBGDiv>
    )
}

export default AlertBox;